import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../Pages/Dashboard";

// Firms
import Firm from "../Pages/Firms/FirmsTable.jsx";
import FirmsSetting from "../Pages/Firms/FirmsSetting.js";
import CreateFirm from "../Pages/Firms/CreateFirm.js";
import SwitchFirm from "../Pages/Firms/SwitchFirm.js";
import UserManage from "../Pages/Firms/UserManage.jsx";

// Profile
import ProfileSettings from "../Pages/Settings/ProfileSettings.jsx";

// Authentication
import Logout from "../Pages/AuthenticationPages/Logout.js";
// import Register from "../Pages/AuthenticationPages/Register.js";
import ResetPassword from "../Pages/AuthenticationPages/ResetPassword.jsx";
import Login1 from "../Pages/AuthenticationPages/Login";
import RecoverPassword from "../Pages/AuthenticationPages/RecoverPassword";
import LockScreen from "../Pages/AuthenticationPages/LockScreen";
import VerifyOtp from "../Pages/AuthenticationPages/VerifyOtp.jsx";

// Utility
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";
import CreateUser from "../Pages/Team/CreateUser/index.jsx";

// Teams 
import AllUsers from "../Pages/Team/Users/index.jsx";
import Departments from "../Pages/Team/Departments/index.jsx";
import Designations from "../Pages/Team/Designations/index.jsx";
import UserActivityLogs from "../Pages/Team/UserActivityLogs/index.jsx";
import ProjectsList from "../Pages/Projects/ProjectsList.jsx";
import AmenitiesList from "../Pages/Amenities/AmenitiesList.jsx";
import ProjectDetails from "../Pages/Projects/ProjectDetails.jsx";
import FbLeads from "../Pages/FbLeadgen/FbLeads.jsx";
import StagesList from "../Pages/Stages/StagesList.jsx";
import BuildersList from "../Pages/Builders/BuildersList.jsx";
import TokenManager from "../Pages/Settings/TokenManager.jsx";
import FbFormsManager from "../Pages/Settings/FbFormsManager/FbFormsManager.jsx";
import ProjectFormRelation from "../Pages/ProjectFormRelation/ProjectFormRelation.jsx";
import Tasks from "../Pages/Tasks/Index.jsx";
import AutomationRulePage from "../Pages/AutomationRules/Index.jsx";
import UserLeads from "../Pages/UserLeads/UserLeads";
import NewLeads from "../Pages/UserLeads/NewLeads.jsx";
import LeadDetails from "../Pages/UserLeads/LeadDetails";
import RuleUsers from "../Pages/AutomationRules/RuleUsers.jsx";
import Permissions from "../Pages/Permissions/Permissions.jsx";
import PermissionsManager from "../Pages/PermissionsManager/index.jsx";
import ResaleInventoryList from "../Pages/ResaleInventory/ResaleInventoryList.jsx";
import MailerDashboard from "../Pages/Mailer/MailerDashboard.jsx";
import HrmsAttendance from "../Pages/HRMS/Attendance.jsx";
import HrmsLeaves from "../Pages/HRMS/Leaves.jsx";

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: <Dashboard /> },

  // ================= HRMS =================
  { path: "/hrms/attendance", component: <HrmsAttendance /> },
  { path: "/hrms/leaves", component: <HrmsLeaves /> },

  // Firms
  { path: "/firms", component: <Firm /> },
  { path: "/firmusers", component: <UserManage /> },
  { path: "/firms-setting", component: <FirmsSetting /> },
  { path: "/create-firm", component: <CreateFirm /> },
  { path: "/switch-firm", component: <SwitchFirm /> },

  // ================= TEAM =================  
  { path: "/team/users", component: <AllUsers /> },
  { path: "/team/users/create", component: <CreateUser /> },
  { path: "/team/permissions", component: <ComingSoon /> },
  { path: "/team/departments", component: <Departments /> },
  { path: "/team/designations", component: <Designations /> },
  { path: "/team/user-activity-logs", component: <UserActivityLogs /> },
  
  // ================= Projects & Properties =================  
  { path: "/projects", component: <ProjectsList /> },
  { path: "/properties/resale", component: <ResaleInventoryList /> },
  { path: "/project-details/:slug", component: <ProjectDetails /> },
  { path: "/project-form-relation", component: <ProjectFormRelation /> },
  { path: "/settings/system/amenities", component: <AmenitiesList /> },
  { path: "/settings/system/token-manager", component: <TokenManager /> },
  { path: "/settings/system/fb-forms-manager", component: <FbFormsManager /> },
  { path: "/settings/system/stages", component: <StagesList /> },
  // { path: "/projects/create", element: <ProjectForm /> },
  // { path: "/projects/:id", element: <ProjectDetails /> },
  // { path: "/projects/:id/edit", element: <ProjectForm /> }
  
  // ================= Leads =================  
  { path: "/all-leads", component: <FbLeads /> },
  { path:"/my-leads", component:<UserLeads /> },
  { path: "/new-leads", component: <NewLeads /> },
  { path:"/user-leads-page/:userId", component:<UserLeads /> },
  
  // { path:"/lead-details/:leadId", component:<LeadDetails />}, 

  { path:"/lead-details/:source/:leadId", component:<LeadDetails />},
  
  // ================= TASKS =================  
  { path: "/all-tasks", component: <Tasks /> },
  
  // ================= ASSIGNMENTS =================  
  { path: "/settings/assignment-rules", component: <AutomationRulePage /> },
  { path: "/lead-rules", component: <AutomationRulePage /> },
  { path: "/rule-users", component: <RuleUsers /> },

  // ================= Builders =================
  { path: "/builders", component: <BuildersList /> },
  
  // Profile
  { path: "/userprofile", component: <ProfileSettings /> },
  { path: "/permissions-page", component: <Permissions /> },
  { path: "/permissions-manager", component: <PermissionsManager /> },
  { path: "/profile-settings", component: <ProfileSettings /> },
  { path: "/coming-soon", component: <ComingSoon /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login1 /> },
  { path: "/forgot-password", component: <RecoverPassword /> },
  { path: "/recover-password", component: <RecoverPassword /> },
  { path: "/register", component: <Error404 /> },
  // { path: "/register", component: <Register /> },
  // { path: "/reset-password/:token", component: <ResetPassword /> },
  // { path: "/reset-password", component: <Navigate to="/login" /> },
  { path: "/verify-email", component: <VerifyOtp /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  {path:"/reset-password" ,component:<ResetPassword />},

  // Errors
  { path: "/pages-404", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },

  // Utility
  { path: "/maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },

  { path: "/*", component: <Error404 /> },
];

export { authProtectedRoutes, publicRoutes };